import { writable } from "svelte/store";
import { l } from "$lib/Utils/l10n.svelte";

const reason = writable("");

const titleStore = {
  subscribe: reason.subscribe,
  set: reason.set,
  clear: () => {
    reason.set("");
  },
};
export default titleStore;
